const styles = {
  errorContainer: {
    textAlign: `center`,
    color: `red`
  },
  messageContainer: {
    textAlign: `center`
  },
  icon: {
    fontSize: 24
  },
  inputContainer: {
    display: `flex`,
    flexDirection: `row`,
    justifyContent: `flex-start`,
    width: `100%`
  },
  inputButton: {
    height: `fit-content`,
    marginLeft: 10,
    marginTop: 5
  }
};

export default styles;
